<template>
  <div class="contact-bg py-5 px-2 px-md-0">
    <div class="container" style="max-width: 960px;">

      <!-- Titlu Pagină -->
      <div class="text-center mb-5 animate__animated animate__fadeInDown">
        <h2 class="fw-bold text-primary display-6">
          <i class="fas fa-envelope-open-text me-2"></i> Contactează-ne
        </h2>
        <p class="text-muted mt-2 mx-auto" style="max-width: 520px;">
          Scrie-ne prin formular, sună-ne sau trimite un e-mail – răspundem în cel mai scurt timp.
        </p>
      </div>

      <div class="row g-4 align-items-start">

        <!-- Stânga: Informații de contact -->
        <div class="col-12 col-lg-4 animate__animated animate__fadeInLeft">

          <!-- Info card -->
          <div class="info-card rounded-4 shadow-sm p-4 mb-3">
            <h5 class="fw-bold text-primary mb-4">
              <i class="fas fa-building me-2"></i> Date de contact
            </h5>

            <div class="contact-item">
              <div class="contact-icon-wrap">
                <i class="fas fa-map-marker-alt text-primary"></i>
              </div>
              <div>
                <div class="label">Adresă</div>
                <div class="value">Calea Apeductului, nr. 13, bloc A1, sc. 1, et. 1, ap. 7<br/>Sector 6, București</div>
              </div>
            </div>

            <div class="contact-item">
              <div class="contact-icon-wrap">
                <i class="fas fa-envelope text-primary"></i>
              </div>
              <div>
                <div class="label">Email</div>
                <a href="mailto:achizitiiprofesionale@gmail.com" class="value text-decoration-none text-dark">
                  achizitiiprofesionale@gmail.com
                </a>
              </div>
            </div>

            <div class="contact-item">
              <div class="contact-icon-wrap">
                <i class="fas fa-phone-alt text-primary"></i>
              </div>
              <div>
                <div class="label">Telefon</div>
                <a href="tel:+40766718238" class="value text-decoration-none text-dark fw-semibold">
                  +40 766 718 238
                </a>
              </div>
            </div>

            <div class="contact-item mb-0">
              <div class="contact-icon-wrap">
                <i class="fas fa-clock text-primary"></i>
              </div>
              <div>
                <div class="label">Program</div>
                <div class="value">Luni – Vineri: 09:00 – 17:00</div>
              </div>
            </div>
          </div>

          <!-- Alert cont client -->
          <div class="alert-tip rounded-3 p-3 d-flex gap-2 align-items-start">
            <i class="fas fa-user-plus text-primary mt-1 flex-shrink-0"></i>
            <span class="small">Poți crea un <strong>cont de client</strong> pentru a discuta direct cu consultantul nostru pe site.</span>
          </div>
        </div>

        <!-- Dreapta: Formular -->
        <div class="col-12 col-lg-8 animate__animated animate__fadeInRight">
          <div class="form-card rounded-4 shadow-sm p-4">
            <h4 class="fw-bold text-primary mb-4">
              <i class="fas fa-file-alt me-2"></i> Trimite cerere de consultanță
            </h4>

            <form @submit.prevent="submitForm" enctype="multipart/form-data" novalidate>

              <div class="row g-3">
                <!-- Nume -->
                <div class="col-12 col-sm-6">
                  <label class="form-label fw-semibold small">Nume complet <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-user text-primary"></i></span>
                    <input v-model="form.full_name" class="form-control" placeholder="Ion Popescu" required />
                  </div>
                </div>

                <!-- Telefon -->
                <div class="col-12 col-sm-6">
                  <label class="form-label fw-semibold small">Telefon <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-phone text-primary"></i></span>
                    <input v-model="form.phone" type="tel" class="form-control" placeholder="+40 7xx xxx xxx" required />
                  </div>
                </div>

                <!-- Email -->
                <div class="col-12 col-sm-6">
                  <label class="form-label fw-semibold small">Email <span class="text-danger">*</span></label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-envelope text-primary"></i></span>
                    <input type="email" v-model="form.email" class="form-control" placeholder="email@exemplu.ro" required />
                  </div>
                </div>

                <!-- Interval preferat -->
                <div class="col-12 col-sm-6">
                  <label class="form-label fw-semibold small">Interval preferat de contact</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="fas fa-clock text-primary"></i></span>
                    <input v-model="form.preferred_time" class="form-control" placeholder="ex: dimineața / 10-12" />
                  </div>
                </div>

                <!-- Tip cerere -->
                <div class="col-12">
                  <label class="form-label fw-semibold small">Tip cerere <span class="text-danger">*</span></label>
                  <div class="request-type-grid">
                    <label
                      v-for="opt in requestOptions"
                      :key="opt.value"
                      class="request-type-option"
                      :class="{ active: form.request_type === opt.value }"
                    >
                      <input type="radio" v-model="form.request_type" :value="opt.value" class="d-none" />
                      <i :class="['fas', opt.icon, 'me-1']"></i>
                      {{ opt.label }}
                    </label>
                  </div>
                </div>

                <!-- Mesaj -->
                <div class="col-12">
                  <label class="form-label fw-semibold small">Mesaj <span class="text-danger">*</span></label>
                  <textarea v-model="form.message" class="form-control" rows="4" placeholder="Descrie pe scurt situația ta..." required></textarea>
                </div>

                <!-- Fișiere -->
                <div class="col-12">
                  <label class="form-label fw-semibold small">Fișiere atașate <span class="text-muted fw-normal">(opțional)</span></label>
                  <div
                    class="file-drop-area rounded-3 text-center p-3"
                    @dragover.prevent
                    @drop.prevent="onDrop"
                  >
                    <i class="fas fa-cloud-upload-alt fa-2x text-primary mb-2 d-block"></i>
                    <div class="small text-muted mb-2">Trage fișierele aici sau</div>
                    <label class="btn btn-sm btn-outline-primary">
                      Alege fișiere
                      <input type="file" multiple class="d-none" @change="onFilesChange" />
                    </label>
                    <div v-if="form.files.length > 0" class="mt-2 text-start">
                      <div v-for="f in form.files" :key="f.name" class="small text-muted d-flex align-items-center gap-1">
                        <i class="fas fa-file-alt text-primary"></i> {{ f.name }}
                      </div>
                    </div>
                    <div class="small text-muted mt-2">Mai multe documente? Arhivă ZIP</div>
                  </div>
                </div>

                <!-- Captcha -->
                <div class="col-12 col-sm-6">
                  <label class="form-label fw-semibold small">
                    <i class="fas fa-robot text-muted me-1"></i> Cât este 3 + 4? <span class="text-danger">*</span>
                  </label>
                  <input v-model="captcha" type="text" class="form-control" placeholder="Răspuns" required />
                </div>

              </div>

              <div class="mt-4">
                <button
                  type="submit"
                  class="btn btn-primary w-100 py-3 fw-semibold fs-6"
                  :disabled="sending"
                >
                  <span v-if="sending">
                    <span class="spinner-border spinner-border-sm me-2"></span> Se trimite...
                  </span>
                  <span v-else>
                    <i class="fas fa-paper-plane me-2"></i> Trimite cererea
                  </span>
                </button>
              </div>

            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Swal from 'sweetalert2'
import api from '@/api/axios'

const sending = ref(false)

const requestOptions = [
  { value: 'Consultanță generală', label: 'Consultanță generală', icon: 'fa-comments' },
  { value: 'Suport SEAP', label: 'Suport SEAP', icon: 'fa-laptop' },
  { value: 'Verificare documentație', label: 'Verificare documentație', icon: 'fa-file-contract' },
  { value: 'Alt tip', label: 'Alt tip', icon: 'fa-ellipsis-h' },
]

const form = ref({
  full_name: '',
  email: '',
  phone: '',
  request_type: '',
  preferred_time: '',
  message: '',
  files: [],
})
const captcha = ref('')

const onFilesChange = (e) => {
  form.value.files = [...e.target.files]
}

const onDrop = (e) => {
  form.value.files = [...e.dataTransfer.files]
}

const submitForm = async () => {
  if (captcha.value.trim() !== '7') {
    Swal.fire('Eroare', 'Captcha incorect. Încearcă din nou.', 'error')
    return
  }

  const data = new FormData()
  for (const key in form.value) {
    if (key === 'files') {
      form.value.files.forEach((f) => data.append('documents', f))
    } else {
      data.append(key, form.value[key])
    }
  }

  sending.value = true
  try {
    await api.post('/submit-consultancy-request/', data)
    Swal.fire({ icon: 'success', title: 'Cerere trimisă!', text: 'Te vom contacta în cel mai scurt timp.', timer: 3000, showConfirmButton: false })
    form.value = { full_name: '', email: '', phone: '', request_type: '', preferred_time: '', message: '', files: [] }
    captcha.value = ''
  } catch {
    Swal.fire('Eroare!', 'Ceva n-a mers. Încearcă mai târziu.', 'error')
  } finally {
    sending.value = false
  }
}
</script>

<style scoped>
/* Layout */
.contact-bg {
  background: linear-gradient(160deg, #f0f4ff 0%, #f9faff 100%);
  min-height: 100vh;
}

/* Info card */
.info-card {
  background: white;
  border: 1px solid rgba(0,0,0,0.05);
}

.contact-item {
  display: flex;
  gap: 0.85rem;
  margin-bottom: 1.2rem;
  align-items: flex-start;
}

.contact-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(13,110,253,0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.95rem;
}

.label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9ca3af;
  margin-bottom: 2px;
}

.value {
  font-size: 0.88rem;
  color: #374151;
  line-height: 1.5;
}

/* Alert tip */
.alert-tip {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
  font-size: 0.88rem;
}

/* Form card */
.form-card {
  background: white;
  border: 1px solid rgba(0,0,0,0.05);
}

.input-group-text {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.form-control:focus,
.form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.2rem rgba(13,110,253,.15);
}

/* Request type pills */
.request-type-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.request-type-option {
  display: inline-flex;
  align-items: center;
  padding: 0.4rem 0.9rem;
  border: 1.5px solid #dee2e6;
  border-radius: 2rem;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  color: #374151;
  user-select: none;
}

.request-type-option:hover {
  border-color: #0d6efd;
  color: #0d6efd;
  background: #eff6ff;
}

.request-type-option.active {
  background: #0d6efd;
  border-color: #0d6efd;
  color: white;
}

/* File drop */
.file-drop-area {
  border: 2px dashed #cbd5e1;
  background: #f8fafc;
  transition: border-color 0.2s;
}
.file-drop-area:hover {
  border-color: #0d6efd;
}

/* Submit btn */
.btn-primary:not(:disabled) {
  background: linear-gradient(90deg, #0d6efd, #0a85d1);
  border: none;
  transition: opacity 0.2s;
}
.btn-primary:not(:disabled):hover {
  opacity: 0.92;
}

@media (max-width: 576px) {
  .request-type-option {
    font-size: 0.8rem;
    padding: 0.35rem 0.7rem;
  }
  .form-card, .info-card {
    padding: 1.2rem !important;
  }
}
</style>